export const GTMEvents = {
  signUpSubmit: 'lead_signup_submit',
  kycComplete: 'kyc_complete',
  kycInComplete: 'kyc_incomplete',
  userStatus: 'user_status',
  investmentAccountApproved: "investment_account_approved",
  depositApproved: "deposit_approved",
  investmentSubmit: 'investment_submit',
  investmentAbandoned: 'investment_abandoned',
  investmentConfirmed: 'investment_confirmed',
  investedOnce: 'investment_once',
  investedMany: 'invested_many',
  depositRemained: 'deposit_remained'
};